import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export default async function updateRecord({
  record,
  projectIds,
  breakRecordsUpdateAttributes,
  activeEmployerInfo,
}) {
  const apiPath = `records/edit`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { record, projectIds, breakRecordsUpdateAttributes },
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
}
